export default function toPDFMakeData(props: any) {
  return {
    content: [
      {
        decoration: ``,
        fontSize: `18`,
        text: `หนังสือแสดงความยินยอมให้เปิดเผยข้อมูลด้านสุขภาพของบุคคลทางอิเล็กทรอนิกส์`,
        width: `auto`,
        alignment: `center`,
        pageBreak: ``,
        color: ``,
        bold: `true`,
        preserveLeadingSpaces: true,
        decorationColor: ``,
        decorationStyle: ``,
      },
      {
        decorationColor: ``,
        fontSize: 15,
        decorationStyle: ``,
        text: ` `,
        pageBreak: ``,
        preserveLeadingSpaces: true,
        width: `auto`,
        bold: false,
        color: ``,
        alignment: `left`,
        decoration: ``,
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            alignment: `left`,
            color: ``,
            pageBreak: ``,
            decorationColor: ``,
            fontSize: 15,
            text: ``,
            bold: false,
            width: 300,
            decorationStyle: ``,
            decoration: ``,
          },
          {
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            text: `สถานที่ `,
            decoration: ``,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            width: `auto`,
            decorationStyle: ``,
            alignment: `left`,
            color: ``,
          },
          {
            color: ``,
            fontSize: 15,
            width: 5,
            pageBreak: ``,
            text: ``,
            decoration: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            bold: false,
            decorationColor: ``,
          },
          {
            width: `auto`,
            fontSize: 15,
            decorationColor: ``,
            decorationStyle: ``,
            decoration: ``,
            alignment: `center`,
            pageBreak: ``,
            text: `โรงพยาบาลเซเปี้ยนซ์`,
            color: ``,
            bold: false,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        columns: [
          {
            text: ``,
            color: ``,
            pageBreak: ``,
            alignment: `left`,
            width: 300,
            preserveLeadingSpaces: true,
            decoration: ``,
            decorationColor: ``,
            fontSize: 15,
            decorationStyle: ``,
            bold: false,
          },
          {
            decorationStyle: ``,
            width: `auto`,
            bold: false,
            text: `วันที่`,
            color: ``,
            pageBreak: ``,
            alignment: `left`,
            decorationColor: ``,
            fontSize: 15,
            decoration: ``,
            preserveLeadingSpaces: true,
          },
          {
            decorationStyle: ``,
            fontSize: 15,
            bold: false,
            decoration: ``,
            pageBreak: ``,
            color: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            text: ``,
            decorationColor: ``,
            width: 5,
          },
          {
            fontSize: 15,
            decorationStyle: ``,
            pageBreak: ``,
            color: ``,
            decoration: ``,
            width: `auto`,
            text: props.items?.printDay,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            bold: false,
            alignment: `center`,
          },
          {
            text: ``,
            preserveLeadingSpaces: true,
            bold: false,
            decorationColor: ``,
            width: 5,
            decoration: ``,
            decorationStyle: ``,
            pageBreak: ``,
            color: ``,
            fontSize: 15,
            alignment: `left`,
          },
          {
            fontSize: 15,
            color: ``,
            alignment: `left`,
            decorationStyle: ``,
            text: `เดือน `,
            decoration: ``,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            width: `auto`,
            pageBreak: ``,
            bold: false,
          },
          {
            text: ``,
            alignment: `left`,
            color: ``,
            width: 5,
            bold: false,
            pageBreak: ``,
            fontSize: 15,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            decoration: ``,
          },
          {
            bold: false,
            pageBreak: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            width: `auto`,
            decorationColor: ``,
            color: ``,
            decoration: ``,
            alignment: `center`,
            decorationStyle: ``,
            text: props.items?.printMonth,
          },
          {
            alignment: `left`,
            pageBreak: ``,
            decorationStyle: ``,
            color: ``,
            text: ``,
            decoration: ``,
            bold: false,
            fontSize: 15,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            width: 5,
          },
          {
            pageBreak: ``,
            width: `auto`,
            decoration: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            text: `พ.ศ. `,
            bold: false,
            color: ``,
            fontSize: 15,
            decorationColor: ``,
            alignment: `left`,
          },
          {
            text: ``,
            fontSize: 15,
            decorationStyle: ``,
            pageBreak: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            width: 5,
            color: ``,
            alignment: `left`,
            bold: false,
            decorationColor: ``,
          },
          {
            decorationColor: ``,
            bold: false,
            text: props.items?.printYear,
            pageBreak: ``,
            color: ``,
            alignment: `center`,
            width: `auto`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            fontSize: 15,
          },
          {
            text: ``,
            decoration: ``,
            bold: false,
            fontSize: 15,
            decorationStyle: ``,
            width: 5,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            pageBreak: ``,
            alignment: `left`,
            color: ``,
          },
          {
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            bold: false,
            decoration: ``,
            alignment: `left`,
            text: `เวลา `,
            color: ``,
            fontSize: 15,
            pageBreak: ``,
            width: `auto`,
            decorationColor: ``,
          },
          {
            bold: false,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            color: ``,
            width: 5,
            decorationColor: ``,
            decoration: ``,
            text: ``,
            decorationStyle: ``,
            alignment: `left`,
            fontSize: 15,
          },
          {
            width: `auto`,
            decorationStyle: ``,
            alignment: `center`,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            text: props.items?.printTime,
            bold: false,
            decorationColor: ``,
            color: ``,
            fontSize: 15,
            decoration: ``,
          },
          {
            pageBreak: ``,
            fontSize: 15,
            bold: false,
            color: ``,
            decoration: ``,
            width: 5,
            preserveLeadingSpaces: true,
            alignment: `left`,
            decorationStyle: ``,
            text: ``,
            decorationColor: ``,
          },
          {
            alignment: `left`,
            width: `auto`,
            pageBreak: ``,
            decorationStyle: ``,
            decoration: ``,
            text: `น.`,
            bold: false,
            color: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            fontSize: 15,
          },
        ],
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            alignment: `left`,
            color: ``,
            decorationColor: ``,
            fontSize: 15,
            decorationStyle: ``,
            bold: false,
            width: 300,
            decoration: ``,
            pageBreak: ``,
            text: ``,
          },
          {
            decoration: ``,
            color: ``,
            decorationColor: ``,
            alignment: `left`,
            width: `auto`,
            text: `เลขที่ใบ Consent Form `,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            pageBreak: ``,
            fontSize: 15,
            bold: false,
          },
          {
            color: ``,
            preserveLeadingSpaces: true,
            alignment: `center`,
            width: `auto`,
            text: `................................................`,
            decorationStyle: ``,
            decorationColor: ``,
            decoration: ``,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
          },
        ],
      },
      {
        pageBreak: ``,
        alignment: `left`,
        decorationStyle: ``,
        decoration: ``,
        color: ``,
        bold: false,
        decorationColor: ``,
        text: ` `,
        fontSize: 15,
        preserveLeadingSpaces: true,
        width: `auto`,
      },
      {
        columns: [
          {
            alignment: `left`,
            decoration: ``,
            text: ``,
            color: ``,
            fontSize: 15,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            bold: false,
            width: 30,
            pageBreak: ``,
            decorationStyle: ``,
          },
          {
            bold: false,
            fontSize: 15,
            preserveLeadingSpaces: true,
            text: `1. ข้าพเจ้า`,
            alignment: `left`,
            color: ``,
            decorationColor: ``,
            width: `auto`,
            pageBreak: ``,
            decorationStyle: ``,
            decoration: ``,
          },
          {
            preserveLeadingSpaces: true,
            fontSize: 15,
            color: ``,
            margin: [0, 0, 0, 0],
            pageBreak: ``,
            decoration: ``,
            width: 5,
            decorationColor: ``,
            bold: false,
            text: ` `,
            alignment: `left`,
            decorationStyle: ``,
          },
          {
            stack: [
              {
                preserveLeadingSpaces: true,
                alignment: `center`,
                fontSize: 15,
                color: ``,
                bold: false,
                decoration: ``,
                text: props.items?.full_name,
                pageBreak: ``,
                decorationStyle: ``,
                decorationColor: ``,
                margin: [0, 0, 0, -15],
                width: `auto`,
              },
              {
                decorationStyle: ``,
                decorationColor: ``,
                bold: false,
                alignment: `left`,
                fontSize: 15,
                margin: [0, 0, 0, 0],
                preserveLeadingSpaces: true,
                width: `auto`,
                text: `...........................................................`,
                pageBreak: ``,
                color: ``,
                decoration: ``,
              },
            ],
          },
          {
            alignment: `left`,
            width: `auto`,
            fontSize: 15,
            text: `HN`,
            decoration: ``,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            color: ``,
            decorationStyle: ``,
            decorationColor: ``,
            bold: false,
          },
          {
            decoration: ``,
            color: ``,
            text: ` `,
            bold: false,
            fontSize: 15,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            width: 5,
            alignment: `left`,
            margin: [0, 0, 0, 0],
            decorationStyle: ``,
          },
          {
            stack: [
              {
                margin: [28, 0, 0, -15],
                decoration: ``,
                text: props.items?.hn,
                alignment: `left`,
                preserveLeadingSpaces: true,
                bold: false,
                color: ``,
                width: `auto`,
                decorationColor: ``,
                decorationStyle: ``,
                pageBreak: ``,
                fontSize: 15,
              },
              {
                decorationColor: ``,
                color: ``,
                decorationStyle: ``,
                text: `...........................................`,
                bold: false,
                margin: [0, 0, 0, 0],
                pageBreak: ``,
                decoration: ``,
                alignment: `left`,
                fontSize: 15,
                preserveLeadingSpaces: true,
                width: `auto`,
              },
            ],
          },
          {
            color: ``,
            decorationStyle: ``,
            width: `auto`,
            fontSize: 15,
            margin: [-40, 0, 0, 0],
            bold: false,
            decoration: ``,
            preserveLeadingSpaces: true,
            text: `อายุ`,
            pageBreak: ``,
            alignment: `left`,
            decorationColor: ``,
          },
          {
            width: 5,
            pageBreak: ``,
            alignment: `left`,
            color: ``,
            fontSize: 15,
            bold: false,
            decoration: ``,
            decorationStyle: ``,
            text: ` `,
            margin: [0, 0, 0, 0],
            preserveLeadingSpaces: true,
            decorationColor: ``,
          },
          {
            stack: [
              {
                margin: [0, 0, 0, -15],
                color: ``,
                text: props.items?.age,
                decorationColor: ``,
                width: `auto`,
                decorationStyle: ``,
                alignment: `center`,
                bold: false,
                decoration: ``,
                preserveLeadingSpaces: true,
                fontSize: 15,
                pageBreak: ``,
              },
              {
                pageBreak: ``,
                fontSize: 15,
                margin: [0, 0, 0, 0],
                alignment: `left`,
                decorationColor: ``,
                width: `auto`,
                bold: false,
                preserveLeadingSpaces: true,
                text: `...........................................................`,
                color: ``,
                decoration: ``,
                decorationStyle: ``,
              },
            ],
          },
          {
            decorationStyle: ``,
            fontSize: 15,
            decoration: ``,
            text: `ปี`,
            alignment: `left`,
            pageBreak: ``,
            decorationColor: ``,
            margin: [0, 0, 0, 0],
            preserveLeadingSpaces: true,
            width: `auto`,
            color: ``,
            bold: false,
          },
        ],
      },
      {
        columns: [
          {
            decorationStyle: ``,
            alignment: `left`,
            bold: false,
            pageBreak: ``,
            fontSize: 15,
            width: `auto`,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            color: ``,
            decoration: ``,
            text: `เลขประจำตัวบัตรประชาชน `,
          },
          {
            fontSize: 15,
            alignment: `left`,
            width: 5,
            decorationColor: ``,
            pageBreak: ``,
            bold: false,
            preserveLeadingSpaces: true,
            color: ``,
            decoration: ``,
            decorationStyle: ``,
            text: ``,
          },
          {
            stack: [
              {
                decorationStyle: ``,
                decorationColor: ``,
                alignment: `left`,
                decoration: ``,
                margin: [0, 0, 0, -15],
                preserveLeadingSpaces: true,
                bold: false,
                width: `auto`,
                pageBreak: ``,
                text:
                  props.items?.citizen_no === "" ||
                  props.items?.citizen_no === "Non citizen identity"
                    ? " "
                    : props.items?.citizen_no,
                fontSize: 15,
                color: ``,
              },
              {
                bold: false,
                text: `......................................................................................................................................................................`,
                decorationColor: ``,
                decoration: ``,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
                pageBreak: ``,
                width: `auto`,
                color: ``,
                fontSize: 15,
                decorationStyle: ``,
                alignment: `left`,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            pageBreak: ``,
            decorationStyle: ``,
            fontSize: 15,
            text: `ใบสำคัญประจำตัวคนต่างด้าวเลขที่ `,
            alignment: `left`,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            bold: false,
            width: `auto`,
            color: ``,
            decoration: ``,
          },
          {
            text: ``,
            fontSize: 15,
            decorationStyle: ``,
            alignment: `left`,
            decorationColor: ``,
            decoration: ``,
            bold: false,
            color: ``,
            pageBreak: ``,
            width: 5,
            preserveLeadingSpaces: true,
          },
          {
            stack: [
              {
                color: ``,
                alignment: `left`,
                decorationStyle: ``,
                preserveLeadingSpaces: true,
                decorationColor: ``,
                pageBreak: ``,
                bold: false,
                fontSize: 15,
                decoration: ``,
                width: `auto`,
                text: props.items?.citizen_no
                  ? " "
                  : props.items?.citizen_passport === "" ||
                    props.items?.citizen_passport === "Non citizen identity"
                  ? " "
                  : props.items?.citizen_passport,
                margin: [0, 0, 0, -15],
              },
              {
                margin: [0, 0, 0, 0],
                bold: false,
                fontSize: 15,
                width: `auto`,
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                decorationColor: ``,
                pageBreak: ``,
                decoration: ``,
                text: `...........................................................................................................................................................`,
                color: ``,
                alignment: `left`,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            decorationColor: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            decoration: ``,
            fontSize: 15,
            color: ``,
            pageBreak: ``,
            bold: false,
            width: `auto`,
            decorationStyle: ``,
            text: `อื่นๆ เช่น หนังสือเดินทางเลขที่  `,
          },
          {
            preserveLeadingSpaces: true,
            color: ``,
            decoration: ``,
            bold: false,
            fontSize: 15,
            decorationStyle: ``,
            pageBreak: ``,
            alignment: `left`,
            decorationColor: ``,
            width: 5,
            text: ``,
          },
          {
            stack: [
              {
                pageBreak: ``,
                decorationStyle: ``,
                decoration: ``,
                width: `auto`,
                decorationColor: ``,
                margin: [0, 0, 0, -15],
                text: props.items?.citizen_no
                  ? " "
                  : props.items?.citizen_passport === "" ||
                    props.items?.citizen_passport === "Non citizen identity"
                  ? " "
                  : props.items?.citizen_passport,
                preserveLeadingSpaces: true,
                fontSize: 15,
                bold: false,
                color: ``,
                alignment: `left`,
              },
              {
                decorationColor: ``,
                decorationStyle: ``,
                color: ``,
                fontSize: 15,
                decoration: ``,
                pageBreak: ``,
                text: `................................................................................................................................................................`,
                alignment: `left`,
                preserveLeadingSpaces: true,
                width: `auto`,
                margin: [0, 0, 0, 0],
                bold: false,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            bold: false,
            text: `วันออกบัตร`,
            color: ``,
            width: `auto`,
            fontSize: 15,
            decorationStyle: ``,
            pageBreak: ``,
            alignment: `left`,
            decoration: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
          },
          {
            decoration: ``,
            width: 5,
            pageBreak: ``,
            decorationStyle: ``,
            alignment: `left`,
            margin: [0, 0, 0, 0],
            bold: false,
            color: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            fontSize: 15,
            text: ` `,
          },
          {
            decorationColor: ``,
            alignment: `center`,
            color: ``,
            bold: false,
            text: `..................................................................................`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            width: `auto`,
            fontSize: 15,
            decoration: ``,
          },
          {
            width: 10,
            alignment: `left`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            text: ``,
            decoration: ``,
            pageBreak: ``,
            color: ``,
            fontSize: 15,
            bold: false,
            decorationColor: ``,
          },
          {
            decorationStyle: ``,
            text: `วันหมดอายุ`,
            decoration: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            color: ``,
            width: `auto`,
            decorationColor: ``,
            pageBreak: ``,
            alignment: `left`,
            bold: false,
          },
          {
            decorationColor: ``,
            pageBreak: ``,
            decoration: ``,
            width: 5,
            decorationStyle: ``,
            color: ``,
            margin: [0, 0, 0, 0],
            bold: false,
            fontSize: 15,
            preserveLeadingSpaces: true,
            text: ``,
            alignment: `left`,
          },
          {
            decorationColor: ``,
            pageBreak: ``,
            decoration: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            text: `.....................................................................................`,
            decorationStyle: ``,
            alignment: `center`,
            bold: false,
            width: `auto`,
            color: ``,
          },
        ],
      },
      {
        columns: [
          {
            text: `ออกให้โดย `,
            fontSize: 15,
            decorationColor: ``,
            color: ``,
            decoration: ``,
            width: `auto`,
            alignment: `left`,
            decorationStyle: ``,
            pageBreak: ``,
            bold: false,
            preserveLeadingSpaces: true,
          },
          {
            text: ` `,
            fontSize: 15,
            decoration: ``,
            color: ``,
            alignment: `left`,
            pageBreak: ``,
            decorationColor: ``,
            width: 5,
            bold: false,
            decorationStyle: ``,
            margin: [0, 0, 0, 0],
            preserveLeadingSpaces: true,
          },
          {
            width: `auto`,
            decorationStyle: ``,
            pageBreak: ``,
            alignment: `center`,
            decorationColor: ``,
            decoration: ``,
            color: ``,
            bold: false,
            preserveLeadingSpaces: true,
            fontSize: 15,
            text: `.................................................................................................................................................................................................`,
          },
        ],
      },
      {
        columns: [
          {
            width: `auto`,
            fontSize: 15,
            decorationColor: ``,
            color: ``,
            decorationStyle: ``,
            alignment: `left`,
            decoration: ``,
            text: `ที่อยู่เลขที่`,
            pageBreak: ``,
            bold: false,
            margin: [0, 0, 0, 0],
            preserveLeadingSpaces: true,
          },
          {
            decoration: ``,
            bold: false,
            margin: [0, 0, 0, 0],
            alignment: `left`,
            color: ``,
            decorationStyle: ``,
            text: ` `,
            width: 5,
            decorationColor: ``,
            fontSize: 15,
            pageBreak: ``,
            preserveLeadingSpaces: true,
          },
          {
            stack: [
              {
                preserveLeadingSpaces: true,
                pageBreak: ``,
                width: `auto`,
                decoration: ``,
                text:
                  props.items?.formAddress?.haveAddress === true
                    ? props.items?.formAddress?.no !== ""
                      ? props.items?.formAddress?.no
                      : " "
                    : " ",
                bold: false,
                alignment: `center`,
                decorationStyle: ``,
                decorationColor: ``,
                fontSize: 15,
                color: ``,
                margin: [0, 0, 0, -15],
              },
              {
                bold: false,
                alignment: `left`,
                pageBreak: ``,
                color: ``,
                width: `auto`,
                margin: [0, 0, 0, 0],
                preserveLeadingSpaces: true,
                decoration: ``,
                fontSize: 15,
                decorationStyle: ``,
                text: `....................................`,
                decorationColor: ``,
              },
            ],
          },
          {
            decoration: ``,
            color: ``,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            text: ` หมู่`,
            alignment: `left`,
            pageBreak: ``,
            bold: false,
            margin: [0, 0, 0, 0],
            decorationColor: ``,
            width: `auto`,
            fontSize: 15,
          },
          {
            decorationStyle: ``,
            pageBreak: ``,
            color: ``,
            decoration: ``,
            decorationColor: ``,
            text: ` `,
            margin: [0, 0, 0, 0],
            alignment: `left`,
            bold: false,
            fontSize: 15,
            width: 5,
            preserveLeadingSpaces: true,
          },
          {
            stack: [
              {
                pageBreak: ``,
                decoration: ``,
                fontSize: 15,
                margin: [7, 0, 0, -15],
                width: `auto`,
                bold: false,
                alignment: `left`,
                text:
                  props.items?.formAddress?.haveAddress === true
                    ? props.items?.formAddress?.town !== ""
                      ? props.items?.formAddress?.town
                      : " "
                    : " ",
                color: ``,
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                decorationColor: ``,
              },
              {
                text: `...........`,
                pageBreak: ``,
                decoration: ``,
                preserveLeadingSpaces: true,
                width: `auto`,
                decorationColor: ``,
                bold: false,
                decorationStyle: ``,
                margin: [0, 0, 0, 0],
                fontSize: 15,
                color: ``,
                alignment: `left`,
              },
            ],
          },
          {
            preserveLeadingSpaces: true,
            pageBreak: ``,
            width: `auto`,
            text: `ซอย`,
            color: ``,
            decorationColor: ``,
            alignment: `left`,
            decorationStyle: ``,
            decoration: ``,
            fontSize: 15,
            margin: [-60, 0, 0, 0],
            bold: false,
          },
          {
            fontSize: 15,
            margin: [0, 0, 0, 0],
            decorationColor: ``,
            color: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            width: 5,
            pageBreak: ``,
            bold: false,
            alignment: `left`,
            decorationStyle: ``,
            text: ` `,
          },
          {
            stack: [
              {
                width: `auto`,
                bold: false,
                decoration: ``,
                text:
                  props.items?.formAddress?.haveAddress === true
                    ? props.items?.formAddress?.street !== ""
                      ? props.items?.formAddress?.street
                      : " "
                    : " ",
                fontSize: 15,
                decorationColor: ``,
                color: ``,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
                decorationStyle: ``,
                alignment: `center`,
                pageBreak: ``,
              },
              {
                decorationStyle: ``,
                decorationColor: ``,
                decoration: ``,
                margin: [0, 0, 0, 0],
                width: `auto`,
                alignment: `left`,
                bold: false,
                preserveLeadingSpaces: true,
                fontSize: 15,
                pageBreak: ``,
                color: ``,
                text: `...................................`,
              },
            ],
          },
          {
            fontSize: 15,
            color: ``,
            preserveLeadingSpaces: true,
            margin: [0, 0, 0, 0],
            decoration: ``,
            decorationColor: ``,
            decorationStyle: ``,
            bold: false,
            pageBreak: ``,
            width: `auto`,
            text: `ถนน`,
            alignment: `left`,
          },
          {
            alignment: `left`,
            fontSize: 15,
            decorationColor: ``,
            color: ``,
            text: ` `,
            preserveLeadingSpaces: true,
            decoration: ``,
            pageBreak: ``,
            bold: false,
            decorationStyle: ``,
            width: 5,
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                fontSize: 15,
                bold: false,
                width: `auto`,
                text:
                  props.items?.formAddress?.haveAddress === true
                    ? props.items?.formAddress?.road !== ""
                      ? props.items?.formAddress?.road
                      : " "
                    : " ",
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                alignment: `center`,
                pageBreak: ``,
                margin: [0, 0, 0, -15],
                decoration: ``,
                decorationColor: ``,
                color: ``,
              },
              {
                decorationColor: ``,
                width: `auto`,
                text: `...................................`,
                fontSize: 15,
                alignment: `left`,
                decorationStyle: ``,
                margin: [0, 0, 0, 0],
                preserveLeadingSpaces: true,
                bold: false,
                decoration: ``,
                color: ``,
                pageBreak: ``,
              },
            ],
          },
          {
            bold: false,
            decorationColor: ``,
            decoration: ``,
            alignment: `left`,
            color: ``,
            width: `auto`,
            text: `ตำบล`,
            pageBreak: ``,
            fontSize: 15,
            decorationStyle: ``,
            margin: [0, 0, 0, 0],
            preserveLeadingSpaces: true,
          },
          {
            color: ``,
            decoration: ``,
            pageBreak: ``,
            decorationStyle: ``,
            bold: false,
            margin: [0, 0, 0, 0],
            text: ` `,
            fontSize: 15,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            alignment: `left`,
            width: 5,
          },
          {
            stack: [
              {
                bold: false,
                pageBreak: ``,
                width: `auto`,
                decoration: ``,
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                fontSize: 15,
                alignment: `center`,
                color: ``,
                decorationColor: ``,
                text:
                  props.items?.formAddress?.haveAddress === true
                    ? props.items?.formAddress?.city !== ""
                      ? props.items?.formAddress?.city
                      : " "
                    : " ",
                margin: [0, 0, 0, -15],
              },
              {
                margin: [0, 0, 0, 0],
                decoration: ``,
                decorationColor: ``,
                color: ``,
                bold: false,
                fontSize: 15,
                text: `....................................`,
                preserveLeadingSpaces: true,
                pageBreak: ``,
                alignment: `left`,
                width: `auto`,
                decorationStyle: ``,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            text: `อำเภอ`,
            width: `auto`,
            fontSize: 15,
            alignment: `left`,
            pageBreak: ``,
            decorationColor: ``,
            bold: false,
            color: ``,
            decorationStyle: ``,
            margin: [0, 0, 0, 0],
            decoration: ``,
          },
          {
            decorationColor: ``,
            fontSize: 15,
            pageBreak: ``,
            alignment: `left`,
            color: ``,
            bold: false,
            preserveLeadingSpaces: true,
            text: ` `,
            width: 5,
            decoration: ``,
            decorationStyle: ``,
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                width: `auto`,
                decoration: ``,
                text:
                  props.items?.formAddress?.haveAddress === true
                    ? props.items?.formAddress?.district !== ""
                      ? props.items?.formAddress?.district
                      : " "
                    : " ",
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                bold: false,
                margin: [0, 0, 0, -15],
                decorationColor: ``,
                color: ``,
                alignment: `center`,
                fontSize: 15,
                pageBreak: ``,
              },
              {
                width: `auto`,
                color: ``,
                alignment: `left`,
                bold: false,
                decoration: ``,
                margin: [0, 0, 0, 0],
                decorationColor: ``,
                preserveLeadingSpaces: true,
                text: `.....................................................`,
                pageBreak: ``,
                fontSize: 15,
                decorationStyle: ``,
              },
            ],
          },
          {
            preserveLeadingSpaces: true,
            alignment: `left`,
            fontSize: 15,
            margin: [0, 0, 0, 0],
            decorationStyle: ``,
            bold: false,
            width: `auto`,
            decoration: ``,
            color: ``,
            pageBreak: ``,
            decorationColor: ``,
            text: `จังหวัด`,
          },
          {
            fontSize: 15,
            decorationColor: ``,
            bold: false,
            text: ` `,
            margin: [0, 0, 0, 0],
            width: 5,
            alignment: `left`,
            decoration: ``,
            color: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            pageBreak: ``,
          },
          {
            stack: [
              {
                decorationStyle: ``,
                color: ``,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
                alignment: `center`,
                pageBreak: ``,
                decorationColor: ``,
                width: `auto`,
                bold: false,
                fontSize: 15,
                decoration: ``,
                text:
                  props.items?.formAddress?.haveAddress === true
                    ? props.items?.formAddress?.province !== ""
                      ? props.items?.formAddress?.province
                      : " "
                    : " ",
              },
              {
                fontSize: 15,
                decorationColor: ``,
                pageBreak: ``,
                text: `.....................................................`,
                alignment: `left`,
                width: `auto`,
                preserveLeadingSpaces: true,
                bold: false,
                decoration: ``,
                margin: [0, 0, 0, 0],
                decorationStyle: ``,
                color: ``,
              },
            ],
          },
          {
            fontSize: 15,
            preserveLeadingSpaces: true,
            decoration: ``,
            decorationColor: ``,
            margin: [0, 0, 0, 0],
            width: `auto`,
            pageBreak: ``,
            color: ``,
            alignment: `left`,
            bold: false,
            text: `รหัสไปรษณีย์`,
            decorationStyle: ``,
          },
          {
            pageBreak: ``,
            alignment: `left`,
            width: 5,
            decoration: ``,
            text: ` `,
            bold: false,
            color: ``,
            decorationStyle: ``,
            decorationColor: ``,
            margin: [0, 0, 0, 0],
            preserveLeadingSpaces: true,
            fontSize: 15,
          },
          {
            stack: [
              {
                decorationColor: ``,
                decorationStyle: ``,
                alignment: `center`,
                pageBreak: ``,
                margin: [0, 0, 0, -15],
                color: ``,
                bold: false,
                preserveLeadingSpaces: true,
                decoration: ``,
                text:
                  props.items?.formAddress?.haveAddress === true
                    ? props.items?.formAddress?.zipcode !== ""
                      ? props.items?.formAddress?.zipcode
                      : " "
                    : " ",
                width: `auto`,
                fontSize: 15,
              },
              {
                alignment: `left`,
                fontSize: 15,
                pageBreak: ``,
                color: ``,
                decoration: ``,
                bold: false,
                margin: [0, 0, 0, 0],
                decorationColor: ``,
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                text: `......................................................`,
                width: `auto`,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            text: `เบอร์โทรศัพท์ `,
            preserveLeadingSpaces: true,
            decoration: ``,
            bold: false,
            alignment: `left`,
            width: `auto`,
            decorationStyle: ``,
            fontSize: 15,
            color: ``,
            decorationColor: ``,
            pageBreak: ``,
          },
          {
            text: ``,
            color: ``,
            preserveLeadingSpaces: true,
            bold: false,
            decorationStyle: ``,
            fontSize: 15,
            width: 5,
            decorationColor: ``,
            alignment: `left`,
            pageBreak: ``,
            decoration: ``,
          },
          {
            stack: [
              {
                color: ``,
                alignment: `left`,
                width: `auto`,
                decoration: ``,
                pageBreak: ``,
                fontSize: 15,
                decorationStyle: ``,
                text:
                  props.items?.formAddress?.haveAddress === true
                    ? props.items?.present_address?.tel_mobile
                    : "  ",
                decorationColor: ``,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
                bold: false,
              },
              {
                width: `auto`,
                color: ``,
                decorationColor: ``,
                decoration: ``,
                text: `............................................................................................................................................................................................`,
                decorationStyle: ``,
                alignment: `left`,
                fontSize: 15,
                pageBreak: ``,
                bold: false,
                margin: [0, 0, 0, 0],
                preserveLeadingSpaces: true,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            bold: false,
            decorationStyle: ``,
            fontSize: 15,
            text: `ในฐานะ: `,
            preserveLeadingSpaces: true,
            width: `auto`,
            color: ``,
            decorationColor: ``,
            alignment: `left`,
            decoration: ``,
            pageBreak: ``,
          },
          {
            pageBreak: ``,
            bold: false,
            decorationStyle: ``,
            color: ``,
            text: ``,
            width: 5,
            preserveLeadingSpaces: true,
            alignment: `left`,
            fontSize: 15,
            decorationColor: ``,
            decoration: ``,
          },
          {
            decoration: ``,
            decorationColor: ``,
            width: `auto`,
            text: `....................................................................................................................................................................................................`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            bold: false,
            alignment: `center`,
            color: ``,
            pageBreak: ``,
          },
        ],
      },
      {
        columns: [
          {
            decoration: ``,
            decorationColor: ``,
            color: ``,
            pageBreak: ``,
            width: 30,
            bold: false,
            text: ``,
            decorationStyle: ``,
            alignment: `left`,
            fontSize: 15,
            preserveLeadingSpaces: true,
          },
          {
            text: `2. ข้าพเจ้าทราบเงื่อนไขและข้อตกลงในการใช้บริการ โครงการพัฒนาระเบียนสุขภาพส่วนบุคคล (Personal Health`,
            width: `auto`,
            fontSize: 15,
            decoration: ``,
            decorationColor: ``,
            pageBreak: ``,
            decorationStyle: ``,
            alignment: `left`,
            bold: false,
            color: ``,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        color: ``,
        fontSize: 15,
        pageBreak: ``,
        bold: false,
        width: `auto`,
        decorationColor: ``,
        decorationStyle: ``,
        alignment: `left`,
        decoration: ``,
        preserveLeadingSpaces: true,
        text: `Record : PHRs) (โรงพยาบาลเซเปี้ยนซ์) และการให้คำยินยอมให้โรงพยาบาลเซเปี้ยนซ์ สามารถนำข้อมูลระดับบุคคลไปใช้ประโยชน์ ในการบริการ ดูแลสุขภาพและแลกเปลี่ยนข้อมูลระหว่างสถานพยาบาล อาทิการจัดเก็บข้อมูลการตรวจรักษา/การผ่าตัด/การใช้ยา/การตรวจรักษาทางรังสีและกระทำหัตถการ ทั้งนี้ รวมถึงความเสี่ยงผลข้างเคียงและภาวะแทรกซ้อนไว้ โดยวิธีการทางอิเล็กทรอนิกส์ เพื่อประโยชน์ในการดูแลสุขภาพของข้าพเจ้า`,
      },
      {
        columns: [
          {
            bold: false,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            decorationColor: ``,
            width: 30,
            text: ``,
            decorationStyle: ``,
            fontSize: 15,
            color: ``,
            alignment: `left`,
          },
          {
            decorationStyle: ``,
            width: `auto`,
            color: ``,
            decoration: ``,
            bold: false,
            pageBreak: ``,
            alignment: `left`,
            decorationColor: ``,
            fontSize: 15,
            text: `3. ข้าพเจ้า `,
            preserveLeadingSpaces: true,
          },
          {
            preserveLeadingSpaces: true,
            width: 5,
            fontSize: 15,
            text: ``,
            decoration: ``,
            decorationColor: ``,
            pageBreak: ``,
            alignment: `left`,
            bold: false,
            decorationStyle: ``,
            color: ``,
          },
          {
            preserveLeadingSpaces: true,
            text: `[  ]`,
            width: `auto`,
            color: ``,
            decorationStyle: ``,
            pageBreak: ``,
            alignment: `center`,
            decorationColor: ``,
            bold: false,
            decoration: ``,
            fontSize: 15,
          },
          {
            width: 5,
            decorationStyle: ``,
            color: ``,
            alignment: `left`,
            fontSize: 15,
            decorationColor: ``,
            decoration: ``,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            text: ``,
            bold: false,
          },
          {
            bold: false,
            width: `auto`,
            preserveLeadingSpaces: true,
            text: `ยินยอมเข้าสู่โครงการพัฒนาระบบระเบียนสุขภาพส่วนบุคคล (PHRs)`,
            decorationColor: ``,
            pageBreak: ``,
            decoration: ``,
            color: ``,
            decorationStyle: ``,
            alignment: `left`,
            fontSize: 15,
          },
        ],
      },
      {
        columns: [
          {
            width: 76,
            bold: false,
            decorationColor: ``,
            decoration: ``,
            fontSize: 15,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            color: ``,
            alignment: `left`,
            text: ``,
            pageBreak: ``,
          },
          {
            pageBreak: ``,
            text: `[  ]`,
            bold: false,
            color: ``,
            decoration: ``,
            decorationStyle: ``,
            alignment: `center`,
            decorationColor: ``,
            fontSize: 15,
            width: `auto`,
            preserveLeadingSpaces: true,
          },
          {
            width: 5,
            alignment: `left`,
            decorationColor: ``,
            color: ``,
            bold: false,
            fontSize: 15,
            decorationStyle: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            text: ``,
            pageBreak: ``,
          },
          {
            pageBreak: ``,
            text: `ยินยอมให้สถานพยาบาลเปิดเผยข้อมูล/ส่งข้อมูลทางอิเล็กทรอนิกส์ (สำเนาข้อมูล)`,
            width: `auto`,
            fontSize: 15,
            alignment: `left`,
            color: ``,
            decorationColor: ``,
            decoration: ``,
            decorationStyle: ``,
            bold: false,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        columns: [
          {
            alignment: `left`,
            width: 76,
            pageBreak: ``,
            fontSize: 15,
            color: ``,
            decorationStyle: ``,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            bold: false,
            text: `                   `,
          },
          {
            color: ``,
            alignment: `center`,
            text: `[  ]`,
            decorationStyle: ``,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            decoration: ``,
            bold: false,
            width: `auto`,
            pageBreak: ``,
          },
          {
            decoration: ``,
            color: ``,
            width: 5,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            decorationColor: ``,
            bold: false,
            text: ``,
            decorationStyle: ``,
            alignment: `left`,
          },
          {
            color: ``,
            pageBreak: ``,
            alignment: `left`,
            fontSize: 15,
            bold: false,
            decoration: ``,
            text: `ยินยอมให้สถานพยาบาลนำข้อมูลทางอิเล็กทรอนิกส์ (สำเนาข้อมูล) ใช้ในการศึกษาและวิจัยเพื่อประโยชน์`,
            width: `auto`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
          },
        ],
      },
      {
        columns: [
          {
            preserveLeadingSpaces: true,
            decorationColor: ``,
            color: ``,
            alignment: `left`,
            width: 100,
            pageBreak: ``,
            decorationStyle: ``,
            text: ``,
            decoration: ``,
            bold: false,
            fontSize: 15,
          },
          {
            fontSize: 15,
            bold: false,
            color: ``,
            text: `ทางการแพทย์และสาธารณสุขได้`,
            decorationStyle: ``,
            decorationColor: ``,
            alignment: `left`,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            width: `auto`,
          },
        ],
      },
      {
        bold: false,
        decoration: ``,
        text: `เพื่อการรักษาพยาบาลแก่ผู้ประกอบวิชาชีพด้านสาธารณสุข (บุคลากรที่ได้รับอนุญาต) ให้บริการรักษาได้ ในการรักษาพยาบาลและ`,
        decorationColor: ``,
        fontSize: 15,
        width: `auto`,
        preserveLeadingSpaces: true,
        alignment: `left`,
        decorationStyle: ``,
        color: ``,
        pageBreak: ``,
      },
      {
        text: `สถานพยาบาลที่ให้บริการรักษาได้`,
        pageBreak: ``,
        bold: false,
        decorationStyle: ``,
        decorationColor: ``,
        alignment: `left`,
        width: `auto`,
        preserveLeadingSpaces: true,
        decoration: ``,
        fontSize: 15,
        color: ``,
      },
      {
        columns: [
          {
            color: ``,
            decorationColor: ``,
            text: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            alignment: `left`,
            pageBreak: ``,
            decorationStyle: ``,
            width: 76,
            bold: false,
            fontSize: 15,
          },
          {
            decoration: ``,
            fontSize: 15,
            width: `auto`,
            decorationStyle: ``,
            text: `[  ]`,
            preserveLeadingSpaces: true,
            alignment: `center`,
            bold: false,
            color: ``,
            pageBreak: ``,
            decorationColor: ``,
          },
          {
            text: ``,
            bold: false,
            fontSize: 15,
            decoration: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            color: ``,
            alignment: `left`,
            width: 5,
            pageBreak: ``,
            decorationColor: ``,
          },
          {
            bold: false,
            pageBreak: ``,
            text: `ไม่ยินยอม* ให้สถานพยาบาลเปิดเผยข้อมูล/ส่งข้อมูลทางอิเล็กทรอนิกส์ (สำเนาข้อมูล)`,
            alignment: `left`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            decoration: ``,
            decorationColor: ``,
            color: ``,
            width: `auto`,
          },
        ],
      },
      {
        columns: [
          {
            alignment: `left`,
            color: ``,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            text: `		       `,
            fontSize: 15,
            width: 76,
            decoration: ``,
            bold: false,
            decorationColor: ``,
            pageBreak: ``,
          },
          {
            decorationColor: ``,
            width: `auto`,
            decoration: ``,
            decorationStyle: ``,
            pageBreak: ``,
            color: ``,
            preserveLeadingSpaces: true,
            text: `[  ]`,
            alignment: `center`,
            bold: false,
            fontSize: 15,
          },
          {
            color: ``,
            decorationStyle: ``,
            decorationColor: ``,
            pageBreak: ``,
            text: ``,
            width: 5,
            fontSize: 15,
            decoration: ``,
            alignment: `left`,
            bold: false,
            preserveLeadingSpaces: true,
          },
          {
            alignment: `left`,
            decorationColor: ``,
            width: `auto`,
            pageBreak: ``,
            decorationStyle: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            decoration: ``,
            text: `ไม่ยินยอม* ให้สถานพยาบาลนำข้อมูลทางอิเล็กทรอนิกส์ (สำเนาข้อมูล) ใช้ในการศึกษาและวิจัยเพื่อ`,
            bold: false,
            color: ``,
          },
        ],
      },
      {
        columns: [
          {
            decoration: ``,
            alignment: `left`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            color: ``,
            bold: false,
            fontSize: 15,
            pageBreak: ``,
            text: ``,
            width: 100,
            decorationColor: ``,
          },
          {
            text: `ประโยชน์ทางการแพทย์และสาธารณสุขได้`,
            width: `auto`,
            decorationColor: ``,
            decorationStyle: ``,
            fontSize: 15,
            decoration: ``,
            alignment: `left`,
            pageBreak: ``,
            bold: false,
            preserveLeadingSpaces: true,
            color: ``,
          },
        ],
      },
      {
        width: `auto`,
        decorationStyle: ``,
        fontSize: 15,
        preserveLeadingSpaces: true,
        bold: false,
        decoration: ``,
        pageBreak: ``,
        decorationColor: ``,
        text: `เพื่อการรักษาพยาบาลแก่ผู้ประกอบวิชาชีพด้านสาธารณสุข (บุคลากรที่ได้รับอนุญาต) ให้บริการรักษาได้ ในการรักษาพยาบาล`,
        color: ``,
        alignment: `left`,
      },
      {
        bold: false,
        width: `auto`,
        decorationStyle: ``,
        decorationColor: ``,
        color: ``,
        text: `และสถานพยาบาลที่ให้บริการรักษาได้`,
        alignment: `left`,
        decoration: ``,
        pageBreak: `after`,
        fontSize: 15,
        preserveLeadingSpaces: true,
      },
      {
        columns: [
          {
            pageBreak: ``,
            fontSize: 15,
            width: 30,
            alignment: `left`,
            bold: false,
            color: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            decorationColor: ``,
            text: ``,
            decoration: ``,
          },
          {
            preserveLeadingSpaces: true,
            width: `auto`,
            alignment: `left`,
            text: `4. หากสถานพยาบาลนำข้อมูลสุขภาพส่วนบุคคลของข้าพเจ้าไปใช้เพื่อการอื่นใดอันไม่เป็นประโยชน์ต่อการรักษาพยาบาล`,
            decoration: ``,
            bold: false,
            decorationColor: ``,
            decorationStyle: ``,
            color: ``,
            fontSize: 15,
            pageBreak: ``,
          },
        ],
      },
      {
        text: `ต้องได้รับความยินยอมจากข้าพเจ้าเว้นแต่การเปิดเผยตามที่กฎหมายบัญญัติหรือมีคำสั่งศาลให้เปิดเผย`,
        decorationColor: ``,
        width: `auto`,
        pageBreak: ``,
        bold: false,
        decoration: ``,
        decorationStyle: ``,
        color: ``,
        alignment: `left`,
        preserveLeadingSpaces: true,
        fontSize: 15,
      },
      {
        columns: [
          {
            alignment: `left`,
            decorationStyle: ``,
            decorationColor: ``,
            fontSize: 15,
            decoration: ``,
            preserveLeadingSpaces: true,
            text: ``,
            color: ``,
            width: 30,
            bold: false,
            pageBreak: ``,
          },
          {
            pageBreak: ``,
            fontSize: 15,
            width: `auto`,
            preserveLeadingSpaces: true,
            decoration: ``,
            decorationColor: ``,
            decorationStyle: ``,
            text: `5. ข้าพเจ้า สามารถยกเลิกความยินยอมได้ แต่ไม่มีผลลบล้างความยินยอมและผลแห่งความยินยอมซึ่งได้กระทำไปแล้วก่อน`,
            bold: false,
            color: ``,
            alignment: `left`,
          },
        ],
      },
      {
        width: `auto`,
        color: ``,
        decoration: ``,
        decorationColor: ``,
        decorationStyle: ``,
        fontSize: 15,
        pageBreak: ``,
        bold: false,
        alignment: `left`,
        preserveLeadingSpaces: true,
        text: `หน้านั้น โดยการยกเลิกความยินยอมต้องมีหลักฐานเป็นลายลักษณ์อักษร`,
      },
      {
        decorationColor: ``,
        decoration: ``,
        fontSize: 15,
        pageBreak: ``,
        color: ``,
        decorationStyle: ``,
        bold: false,
        text: ` `,
        width: `auto`,
        preserveLeadingSpaces: true,
        alignment: `left`,
      },
      {
        columns: [
          {
            width: 300,
            alignment: `left`,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            text: ``,
            color: ``,
            bold: false,
            pageBreak: ``,
            fontSize: 15,
            decorationColor: ``,
            decoration: ``,
          },
          {
            bold: false,
            decorationColor: ``,
            decorationStyle: ``,
            decoration: ``,
            fontSize: 15,
            pageBreak: ``,
            width: 200,
            text: `ลงชื่อ.................................................................	`,
            color: ``,
            alignment: `center`,
            preserveLeadingSpaces: true,
          },
        ],
      },
      {
        columns: [
          {
            width: 300,
            pageBreak: ``,
            fontSize: 15,
            decorationColor: ``,
            decorationStyle: ``,
            decoration: ``,
            bold: false,
            alignment: `left`,
            text: ``,
            color: ``,
            preserveLeadingSpaces: true,
          },
          {
            pageBreak: ``,
            fontSize: 15,
            decorationColor: ``,
            bold: false,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            color: ``,
            text: props.items?.full_name,
            width: 200,
            decoration: ``,
            alignment: `center`,
          },
        ],
      },
    ],
    pageOrientation: `portrait`,
    pageSize: `A4`,
    defaultStyle: {
      font: `THSarabunNew`,
    },
    header: props.header,
    footer: props.footer,
  };
}
